var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Component_1 = require("../Component");
var Spinner = (function (_super) {
    __extends(Spinner, _super);
    function Spinner(props) {
        return _super.call(this, props) || this;
    }
    Spinner.prototype.render = function () {
        var customClass = this.props.customClass;
        return (React.createElement("div", { className: 'w--spinner ' + (customClass ? customClass : '') },
            React.createElement("div", { className: "bounce1" }),
            React.createElement("div", { className: "bounce2" }),
            React.createElement("div", { className: "bounce3" })));
    };
    return Spinner;
}(Component_1.default));
exports.default = Spinner;
